var React = require('react');

function GhostIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M43 0a1 1 0 0 1 1 1v47l-7.368-4-6.316 4-7.369-4-6.315 4-6.316-4L4 48V1a1 1 0 0 1 1-1h38zm-7 28H12c1.75 5.367 6.31 8.997 12 8.997 5.811 0 10.353-3.447 12-8.997zM16 9c-2.761 0-5 3.134-5 7s2.239 7 5 7 5-3.134 5-7-2.239-7-5-7zm16 0c-2.761 0-5 3.134-5 7s2.239 7 5 7 5-3.134 5-7-2.239-7-5-7z","fill":"#8D6CFF","key":0}),React.createElement("path",{"opacity":".503","d":"M30 31c-.823 2.194-3.094 4-6 4-2.845 0-5.125-1.878-6-4h12z","fill":"#8D6CFF","key":1}),React.createElement("path",{"opacity":".497","d":"M17.5 16a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM33.5 16a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z","fill":"#8D6CFF","key":2})]);
}

GhostIcon.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = GhostIcon;

GhostIcon.default = GhostIcon;
